<template>
  <div class="case">
    <banner img="c_bg2.jpg" title="精典案例" />
    <!-- <div class="case-section" v-loading="loading"> -->
    <div class="case-section">
      <div class="case-section-content">
        <div class="case-section-content-list" v-for="(cas,index) in caseList" :key="index">
          <div class="img-box">
            <!-- <img v-lazy="imgserver+cas.Img" /> -->
            <img v-lazy="require('../assets/case/'+cas.Img)" alt="背景图" />
            <!-- <img src="../assets/case/SZ.png" /> -->
          </div>
          <div class="content-list-abstract" :class="{'abstract-active' : index%2!=1}">
            <p class="abstract-title">{{cas.Title}}</p>
            <p class="abstract-content">{{cas.Content}}</p>
            <div class="more">
              <router-link
                class="text-decoration"
                :to="{ name: 'casedetails', params: { id: cas.Id }}"
              >
                <span>more</span>
                <img src="../assets/img/sanjiao.png" alt="三角"/>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      imgUrl:require('../assets/case/ZP.png')
      // loading: true,
      // caseList: []
    };
  },
  computed:{
    caseList:function(){
      return this.$store.state.caseAll
    },
  },
  mounted() {
    window.console.log("case");
    // this.$http
    //   .get("Cases/GetCasesAll")
    //   .then(response => {
    //     // console.log(response);
    //     this.caseList = response.data;
    //     //window.console.log(this.caseList);
    //     this.loading = false;
    //   })
    //   .catch(function(error) {
    //     window.console.log(error);
    //   });
  }
};
</script>

 <style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #fff;
  

  &-section {
    width: 100%;
    &-content {
      max-width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        min-height: 500px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        border-bottom: 1px solid pink;
        flex-wrap:wrap;
        padding: 20px;

        img {
          width: 612px;
          height: 314px;
          transition:all .2s;
          &:hover{
            transform:scale(1.03);
          }
        }
        
        .content-list-abstract {
          transition:all .2s;
          &:hover {
            transform:scale(1.03);
            // border: 1px solid #eee;
            // box-shadow: 7px 7px 10px #eee;
          }
          margin-bottom: 20px;
          min-width: 290px;
          max-width: 400px;
          min-height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            // height: 150px;
            color: #484848;
            font-size: 15px;
            text-indent:2em;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;
              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
.img-box{
  max-width: 527px;
  max-height: 300px;
  img{
    width: 407px;
    height: inherit;
    transform: all .3s;
  }
}
@media screen and(max-width:1076px){
  .content-list-abstract{
    order:-1!important;
    max-width: 600px!important;
    min-height: 194px!important;
  }
  .img-box  img{
    width: 287px;
    height: inherit;
  }
}
</style>